export const HANDSHAKE = 'handshake';
export const HANDSHAKE_REPLY = 'handshake-reply';
export const CALL = 'call';
export const REPLY = 'reply';
export const FULFILLED = 'fulfilled';
export const REJECTED = 'rejected';
export const MESSAGE = 'message';
export const DATA_CLONE_ERROR = 'DataCloneError';

export const ERR_CONNECTION_DESTROYED = 'ConnectionDestroyed';
export const ERR_CONNECTION_TIMEOUT = 'ConnectionTimeout';
export const ERR_NOT_IN_IFRAME = 'NotInIframe';
export const ERR_IFRAME_ALREADY_ATTACHED_TO_DOM = 'IframeAlreadyAttachedToDom';

export const CHECK_IFRAME_IN_DOC_INTERVAL = 60000;

export const DEFAULT_PORTS = {
  'http:': '80',
  'https:': '443',
};

export const URL_REGEX = /^(https?:|file:)?\/\/([^/:]+)?(:(\d+))?/;
